<div id="{{dialogId}}" appDraggable dragTarget="#{{dialogId}}" dragHandle="#{{this.getIdForDialogHeader()}}"
	class="modal fade locationAlertDataPane in ui-draggable ui-draggable-handle"
	style="width: auto; min-width: 450px; max-width: 600px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
	role="dialog"
    >
	<div class="modal-dialog-sm" role="document" id="{{ dialogId}}_Document"> <!-- Giving this an ID so it can be referenced to resize the above "role='dialog'" <div>, as it is being drawn with extra space underneath preventing clicks from being detected.  Hacky but works. -->
		<div class="modal-content">
			<div id="{{ this.getIdForDialogHeader() }}" class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
					<span aria-hidden="true">x</span>
				</button>
				<h4 class="modal-title">
					<span><img [src]="getPathForIcon()" /> TAG</span>
					<div style="float: right; padding-right: 40px">{{tag?.name}}</div>
				</h4>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-sm-3" *ngIf="isImagePresent()">
						<div>
							<img [src]="getPathForImage()" width="80">
						</div>
						<div></div>
					</div>
					<div [ngClass]="isImagePresent()? 'col-sm-9' : 'col-sm-12'">
						<div class="row">{{tag?.description}}</div>
						<ng-container *ngFor="let dataField of tag?.data">
							<ng-container *ngIf="dataField.property.mainDisplay == true">
								<div class="row">
									<div class="col-sm-3">{{ dataField.property.name }}:</div>
									<div class="col-sm-9">
										<ng-container *ngIf="dataField.property.type == 'STRING'">
											<ng-container *ngIf="dataField.property.parameter == 'url'">
												<a style="color: #e65100;" href="{{ dataField.value }}" target="_blank">{{ dataField.value }}</a>
											</ng-container>
											<ng-container *ngIf="dataField.property.parameter != 'url'">
												{{ dataField.value }}
											</ng-container>
										</ng-container>
										<ng-container *ngIf="dataField.property.type != 'STRING'">
											{{ dataField.value }}
										</ng-container>
									</div>
								</div>
							</ng-container>
						</ng-container>
						<ng-container *ngIf="isShowFullDetailsNeeded()">
							<ng-container *ngIf="!displayFullDetailsFlag">
								<div class="row" (click)="showFullDetails()">
									<div class="col-sm-12" style="text-align: end; color: red;">+ Show Full Details</div>
								</div>
							</ng-container>
							<ng-container *ngIf="displayFullDetailsFlag">
								<div class="row" (click)="hideFullDetails()">
									<div class="col-sm-12" style="text-align: end; color: red;">- Hide Full Details</div>
								</div>
								<ng-container *ngFor="let dataField of tag?.data">
									<ng-container *ngIf="dataField.property.mainDisplay == false && dataField.property.hidden == false">
										<div class="row">
											<div class="col-sm-3">{{ dataField.property.name }}:</div>
											<div class="col-sm-9">
												<ng-container *ngIf="dataField.property.type == 'STRING'">
													<ng-container *ngIf="dataField.property.parameter == 'url'">
														<a style="color: #e65100;" href="{{ dataField.value }}" target="_blank">{{ dataField.value }}</a>
													</ng-container>
													<ng-container *ngIf="dataField.property.parameter != 'url'">
														{{ dataField.value }}
													</ng-container>
												</ng-container>
												<ng-container *ngIf="dataField.property.type != 'STRING'">
													{{ dataField.value }}
												</ng-container>
											</div>
										</div>
									</ng-container>
								</ng-container>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>